/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `en` - en
 * * `fr` - fr
 * * `de` - de
 * * `es` - es
 * * `it` - it
 * * `ar` - ar
 * @export
 */
export const InformationExtractionLanguageEnum = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
  it: 'it',
  ar: 'ar',
} as const;
export type InformationExtractionLanguageEnum =
  (typeof InformationExtractionLanguageEnum)[keyof typeof InformationExtractionLanguageEnum];

export function instanceOfInformationExtractionLanguageEnum(value: any): boolean {
  for (const key in InformationExtractionLanguageEnum) {
    if (Object.prototype.hasOwnProperty.call(InformationExtractionLanguageEnum, key)) {
      if ((InformationExtractionLanguageEnum as Record<string, InformationExtractionLanguageEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function InformationExtractionLanguageEnumFromJSON(json: any): InformationExtractionLanguageEnum {
  return InformationExtractionLanguageEnumFromJSONTyped(json, false);
}

export function InformationExtractionLanguageEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionLanguageEnum {
  return json as InformationExtractionLanguageEnum;
}

export function InformationExtractionLanguageEnumToJSON(value?: InformationExtractionLanguageEnum | null): any {
  return value as any;
}
